<template>
  <div class="flex h-full max-h-full flex-row gap-3 print:block print:h-auto print:max-h-none">
    <div class="flex w-2/3 flex-col gap-4 overflow-y-auto print:w-full print:h-auto print:overflow-visible">
      <div
        v-if="groupEvents?.length === 0"
        class="flex flex-1 items-center justify-center"
      >
        NO EVENTS
      </div>
      <template v-else>
        <div v-for="(events, index) in groupEvents" :key="index">
          <div
            v-if="index?.length"
            class="bg-primary text-contrast-primary capitalize-first sticky top-0 z-10 mb-4 rounded px-2 py-1 text-base font-bold"
          >
            {{ index }}
          </div>
          <div class="flex flex-col gap-4">
            <EventCard
              v-for="(event, idx) in events"
              :key="event.id"
              v-model:event="events[idx]"
              :has-funeral-home-filter="hasFuneralHomeFilter"
              @fetch-events="$emit('fetch-events')"
              @delete-event="handleDeleteEvent"
            />
          </div>
        </div>
      </template>
    </div>
    <div class="flex w-1/3 flex-col print:hidden">
      <AssignableContainer
        :assignable-people="assignablePeople"
        :assignable-material-resources="assignableMaterialResources"
        :all-users-availability-items="allUsersAvailabilityItems"
        :all-material-resources-availability-items="
          allMaterialResourcesAvailabilityItems
        "
        @fetch-events="$emit('fetch-events')"
      />
    </div>
  </div>
</template>

<script>
import EventCard from './EventCard.vue'
import AssignableContainer from '@c/Dashboard/Content/Planning/components/AssignableContainer.vue'
import { mapActions } from 'vuex'

export default {
  name: 'EventsContainer',
  components: { AssignableContainer, EventCard },
  props: {
    groupEvents: {
      type: Array,
      required: true
    },
    assignablePeople: {
      type: Array,
      required: true
    },
    assignableMaterialResources: {
      type: Array,
      required: true
    },
    allUsersAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    allMaterialResourcesAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    hasFuneralHomeFilter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:events', 'fetch-events'],
  computed: {
    localGroupEvents: {
      get() {
        return this.groupEvents
      },
      set(value) {
        this.$emit('update:events', value)
      }
    }
  },
  methods: {
    ...mapActions({
      processDeleteEventByIdAction: 'planning/deleteEvent',
      processUndoDeleteEventByIdAction: 'planning/undoDeleteEvent'
    }),
    handleDeleteEvent(event_id) {
      this.processDeleteEventByIdAction({
        id: event_id
      }).then((response) => {
        this.$emit('fetch-events')
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_m', { var: this.$t('attributes.event') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => {
                this.undoDelete(event_id)
              }
            }
          ]
        )
      })
    },
    undoDelete(id) {
      this.processUndoDeleteEventByIdAction({
        id: id
      }).then((response) => {
        this.$emit('fetch-events')
      })
    }
  }
}
</script>
